module.exports = __webpack_public_path__ + "files/08b7768fac9eb29f1b126d282a895dcf.svg";